import { StationGroupTable } from '../organisms/StationGroupTable/StationGroupTable';

const StationGroupListPage = () => <StationGroupTable />;

export default StationGroupListPage;
